import styled from "styled-components";
import { TableWrapper } from "../../../components/Table/styled";
import { colors, darkModeColors } from "../../../consts";
import { WrapperContainer } from "../../../components";
import { ButtonsPopupStyled } from "../../../components/ButtonsPopup/styled";

export const ConsentsTableWrapper = styled.div`
  ${TableWrapper} {
    ${(props) => !props?.withAdditionalElement && "margin-bottom: 20px;"}
    tbody {
      max-height: 50vh;
    }
  }
`;

export const ConsentsTableAdditionalElement = styled.div`
  background-color: ${darkModeColors.WHITE_RAISIN_100};
  ${(props) => props?.withBorder && `border-top: 1px solid ${colors.RAISIN_10};`}
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
`;

export const DuplicateButtonWrapper = styled(WrapperContainer)`
  ${ButtonsPopupStyled} {
    width: 260px;
    margin-left: -123px;
  }
`;
